import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';

import axios from 'axios';
import Header from '../Showroom/components/Header/Header';
import SearchBar from '../../components/SearchBar/SearchBar';
import TableList from '../../pages/Showroom/components/TableList/TableList';
import { get_showrooms } from '../../api/API';
const useStyles = makeStyles(theme => ({
    root: {
        padding: 8
    },

    results: {
        marginTop: theme.spacing(3)
    }
}));

// export default function Showroom() {

//     const classes = useStyles();

//     const [showrooms, setShowrooms] = useState([]);
  
//     useEffect(() => {
//         let mounted = true;

//         const fetchAdmins = () => {
//             axios.get('/api/showrooms').then(response => {
//                 if (mounted) {
//                     setShowrooms(response.data.showrooms);
//                 }
//             });
//         };

//         fetchAdmins();

//         return () => {
//             mounted = false;
//         };
//     }, []);

//     const handleSearch = () => {};

//     return (
//         <div
//             className={classes.root}
//             title="Showrooms Details"
//         >
//             <Header />
//             {/* <SearchBar
//                 onSearch={handleSearch}
//             /> */}
//             {showrooms && (
//                 <TableList
//                 className={classes.results}
//                 showrooms={showrooms}
//                 />
//             )}
//         </div>
//     )
// }


export default function Showroom() {

    const classes = useStyles();

    const [showrooms, setShowrooms] = useState([]);
  
    useEffect(() => {
        let mounted = true;

        const fetchShowrooms = async () => {
            let data = await get_showrooms();
            if(data){
                setShowrooms(data);
            }
  
        };

        fetchShowrooms();

        return () => {
            mounted = false;
        };
    }, []);

    const handleFilter = () => {};
    const handleSearch = () => {};

    return (
        <div
            className={classes.root}
            title="Showrooms Details"
        >
            <Header />
            {/* <SearchBar
                onSearch={handleSearch}
            /> */}
            {showrooms && (
                <TableList
                className={classes.results}
                showrooms={showrooms}
                />
            )}
        </div>
    )
}